import { Trans } from '@lingui/react/macro';
import { REVIEW_CLIP_NAME_WORDS } from 'modules/match-video/domain/constants';
import React from 'react';
import UDDisclosure from 'ud-ui/components/disclosure';

/** `опасный момент` → `Опасный момент`: as a person would type it in a file name. */
const asTyped = (word: string) => word.charAt(0).toLocaleUpperCase() + word.slice(1);
const wordList = (words: readonly string[]) => words.map((word) => `«${asTyped(word)}»`).join(', ');

/**
 * How to name the clips so the kind, the order and the scorers fill in by themselves. The words come from
 * `REVIEW_CLIP_NAME_WORDS` — the same list the names are read with, so the hint cannot drift from the parser.
 */
const ClipNamingHint = () => {
  const goalWords = wordList(REVIEW_CLIP_NAME_WORDS.goal);
  const dangerWords = wordList(REVIEW_CLIP_NAME_WORDS.danger);

  return (
    <UDDisclosure summary={<Trans>Как назвать файлы, чтобы всё подставилось само</Trans>} data-testid="match-video-naming-hint">
      <div className="flex flex-col gap-2">
        <p>
          <Trans>
            Имя файла — слово типа и время с камеры: «Goal 21-14-19.mp4», «Гол 21-14-19.mp4», «Опасный момент 21-20-05.mp4». Между
            часами, минутами и секундами — «-», «_», «.» или «:», регистр не важен.
          </Trans>
        </p>
        {/* Markers in markup, not `list-disc`: the global style reset hides list markers. */}
        <ul className="flex flex-col gap-1">
          <li className="flex gap-2">
            <span aria-hidden>•</span>
            <span>
              <Trans>
                {goalWords} — плашка «Гол» с автором гола; {dangerWords} — плашка «Опасный момент»; другое слово — клип без плашки.
              </Trans>
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>•</span>
            <span>
              <Trans>По времени в имени клипы встают по порядку. Клип без времени уходит в конец — передвиньте его стрелками.</Trans>
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>•</span>
            <span>
              <Trans>
                Авторы голов подставляются по порядку: первый клип «Гол» — первый гол протокола, второй — второй. Это работает, когда
                клипов с голами столько же, сколько голов в протоколе; иначе выберите гол у клипа сами.
              </Trans>
            </span>
          </li>
          <li className="flex gap-2">
            <span aria-hidden>•</span>
            <span>
              <Trans>Тип и гол можно поменять у любого клипа в списке, даже если имя другое.</Trans>
            </span>
          </li>
        </ul>
      </div>
    </UDDisclosure>
  );
};

export default ClipNamingHint;
